/*! lazysizes - v5.3.0 */
!function(e){var t=function(u,D,f){"use strict";var k,H;if(function(){var e;var t={lazyClass:"lazyload",loadedClass:"lazyloaded",loadingClass:"lazyloading",preloadClass:"lazypreload",errorClass:"lazyerror",autosizesClass:"lazyautosizes",fastLoadedClass:"ls-is-cached",iframeLoadMode:0,srcAttr:"data-src",srcsetAttr:"data-srcset",sizesAttr:"data-sizes",minSize:40,customMedia:{},init:true,expFactor:1.5,hFac:.8,loadMode:2,loadHidden:true,ricTimeout:0,throttleDelay:125};H=u.lazySizesConfig||u.lazysizesConfig||{};for(e in t){if(!(e in H)){H[e]=t[e]}}}(),!D||!D.getElementsByClassName){return{init:function(){},cfg:H,noSupport:true}}var O=D.documentElement,i=u.HTMLPictureElement,P="addEventListener",$="getAttribute",q=u[P].bind(u),I=u.setTimeout,U=u.requestAnimationFrame||I,o=u.requestIdleCallback,j=/^picture$/i,r=["load","error","lazyincluded","_lazyloaded"],a={},G=Array.prototype.forEach,J=function(e,t){if(!a[t]){a[t]=new RegExp("(\\s|^)"+t+"(\\s|$)")}return a[t].test(e[$]("class")||"")&&a[t]},K=function(e,t){if(!J(e,t)){e.setAttribute("class",(e[$]("class")||"").trim()+" "+t)}},Q=function(e,t){var a;if(a=J(e,t)){e.setAttribute("class",(e[$]("class")||"").replace(a," "))}},V=function(t,a,e){var i=e?P:"removeEventListener";if(e){V(t,a)}r.forEach(function(e){t[i](e,a)})},X=function(e,t,a,i,r){var n=D.createEvent("Event");if(!a){a={}}a.instance=k;n.initEvent(t,!i,!r);n.detail=a;e.dispatchEvent(n);return n},Y=function(e,t){var a;if(!i&&(a=u.picturefill||H.pf)){if(t&&t.src&&!e[$]("srcset")){e.setAttribute("srcset",t.src)}a({reevaluate:true,elements:[e]})}else if(t&&t.src){e.src=t.src}},Z=function(e,t){return(getComputedStyle(e,null)||{})[t]},s=function(e,t,a){a=a||e.offsetWidth;while(a<H.minSize&&t&&!e._lazysizesWidth){a=t.offsetWidth;t=t.parentNode}return a},ee=function(){var a,i;var t=[];var r=[];var n=t;var s=function(){var e=n;n=t.length?r:t;a=true;i=false;while(e.length){e.shift()()}a=false};var e=function(e,t){if(a&&!t){e.apply(this,arguments)}else{n.push(e);if(!i){i=true;(D.hidden?I:U)(s)}}};e._lsFlush=s;return e}(),te=function(a,e){return e?function(){ee(a)}:function(){var e=this;var t=arguments;ee(function(){a.apply(e,t)})}},ae=function(e){var a;var i=0;var r=H.throttleDelay;var n=H.ricTimeout;var t=function(){a=false;i=f.now();e()};var s=o&&n>49?function(){o(t,{timeout:n});if(n!==H.ricTimeout){n=H.ricTimeout}}:te(function(){I(t)},true);return function(e){var t;if(e=e===true){n=33}if(a){return}a=true;t=r-(f.now()-i);if(t<0){t=0}if(e||t<9){s()}else{I(s,t)}}},ie=function(e){var t,a;var i=99;var r=function(){t=null;e()};var n=function(){var e=f.now()-a;if(e<i){I(n,i-e)}else{(o||r)(r)}};return function(){a=f.now();if(!t){t=I(n,i)}}},e=function(){var v,m,c,h,e;var y,z,g,p,C,b,A;var n=/^img$/i;var d=/^iframe$/i;var E="onscroll"in u&&!/(gle|ing)bot/.test(navigator.userAgent);var _=0;var w=0;var M=0;var N=-1;var L=function(e){M--;if(!e||M<0||!e.target){M=0}};var x=function(e){if(A==null){A=Z(D.body,"visibility")=="hidden"}return A||!(Z(e.parentNode,"visibility")=="hidden"&&Z(e,"visibility")=="hidden")};var W=function(e,t){var a;var i=e;var r=x(e);g-=t;b+=t;p-=t;C+=t;while(r&&(i=i.offsetParent)&&i!=D.body&&i!=O){r=(Z(i,"opacity")||1)>0;if(r&&Z(i,"overflow")!="visible"){a=i.getBoundingClientRect();r=C>a.left&&p<a.right&&b>a.top-1&&g<a.bottom+1}}return r};var t=function(){var e,t,a,i,r,n,s,o,l,u,f,c;var d=k.elements;if((h=H.loadMode)&&M<8&&(e=d.length)){t=0;N++;for(;t<e;t++){if(!d[t]||d[t]._lazyRace){continue}if(!E||k.prematureUnveil&&k.prematureUnveil(d[t])){R(d[t]);continue}if(!(o=d[t][$]("data-expand"))||!(n=o*1)){n=w}if(!u){u=!H.expand||H.expand<1?O.clientHeight>500&&O.clientWidth>500?500:370:H.expand;k._defEx=u;f=u*H.expFactor;c=H.hFac;A=null;if(w<f&&M<1&&N>2&&h>2&&!D.hidden){w=f;N=0}else if(h>1&&N>1&&M<6){w=u}else{w=_}}if(l!==n){y=innerWidth+n*c;z=innerHeight+n;s=n*-1;l=n}a=d[t].getBoundingClientRect();if((b=a.bottom)>=s&&(g=a.top)<=z&&(C=a.right)>=s*c&&(p=a.left)<=y&&(b||C||p||g)&&(H.loadHidden||x(d[t]))&&(m&&M<3&&!o&&(h<3||N<4)||W(d[t],n))){R(d[t]);r=true;if(M>9){break}}else if(!r&&m&&!i&&M<4&&N<4&&h>2&&(v[0]||H.preloadAfterLoad)&&(v[0]||!o&&(b||C||p||g||d[t][$](H.sizesAttr)!="auto"))){i=v[0]||d[t]}}if(i&&!r){R(i)}}};var a=ae(t);var S=function(e){var t=e.target;if(t._lazyCache){delete t._lazyCache;return}L(e);K(t,H.loadedClass);Q(t,H.loadingClass);V(t,B);X(t,"lazyloaded")};var i=te(S);var B=function(e){i({target:e.target})};var T=function(e,t){var a=e.getAttribute("data-load-mode")||H.iframeLoadMode;if(a==0){e.contentWindow.location.replace(t)}else if(a==1){e.src=t}};var F=function(e){var t;var a=e[$](H.srcsetAttr);if(t=H.customMedia[e[$]("data-media")||e[$]("media")]){e.setAttribute("media",t)}if(a){e.setAttribute("srcset",a)}};var s=te(function(t,e,a,i,r){var n,s,o,l,u,f;if(!(u=X(t,"lazybeforeunveil",e)).defaultPrevented){if(i){if(a){K(t,H.autosizesClass)}else{t.setAttribute("sizes",i)}}s=t[$](H.srcsetAttr);n=t[$](H.srcAttr);if(r){o=t.parentNode;l=o&&j.test(o.nodeName||"")}f=e.firesLoad||"src"in t&&(s||n||l);u={target:t};K(t,H.loadingClass);if(f){clearTimeout(c);c=I(L,2500);V(t,B,true)}if(l){G.call(o.getElementsByTagName("source"),F)}if(s){t.setAttribute("srcset",s)}else if(n&&!l){if(d.test(t.nodeName)){T(t,n)}else{t.src=n}}if(r&&(s||l)){Y(t,{src:n})}}if(t._lazyRace){delete t._lazyRace}Q(t,H.lazyClass);ee(function(){var e=t.complete&&t.naturalWidth>1;if(!f||e){if(e){K(t,H.fastLoadedClass)}S(u);t._lazyCache=true;I(function(){if("_lazyCache"in t){delete t._lazyCache}},9)}if(t.loading=="lazy"){M--}},true)});var R=function(e){if(e._lazyRace){return}var t;var a=n.test(e.nodeName);var i=a&&(e[$](H.sizesAttr)||e[$]("sizes"));var r=i=="auto";if((r||!m)&&a&&(e[$]("src")||e.srcset)&&!e.complete&&!J(e,H.errorClass)&&J(e,H.lazyClass)){return}t=X(e,"lazyunveilread").detail;if(r){re.updateElem(e,true,e.offsetWidth)}e._lazyRace=true;M++;s(e,t,r,i,a)};var r=ie(function(){H.loadMode=3;a()});var o=function(){if(H.loadMode==3){H.loadMode=2}r()};var l=function(){if(m){return}if(f.now()-e<999){I(l,999);return}m=true;H.loadMode=3;a();q("scroll",o,true)};return{_:function(){e=f.now();k.elements=D.getElementsByClassName(H.lazyClass);v=D.getElementsByClassName(H.lazyClass+" "+H.preloadClass);q("scroll",a,true);q("resize",a,true);q("pageshow",function(e){if(e.persisted){var t=D.querySelectorAll("."+H.loadingClass);if(t.length&&t.forEach){U(function(){t.forEach(function(e){if(e.complete){R(e)}})})}}});if(u.MutationObserver){new MutationObserver(a).observe(O,{childList:true,subtree:true,attributes:true})}else{O[P]("DOMNodeInserted",a,true);O[P]("DOMAttrModified",a,true);setInterval(a,999)}q("hashchange",a,true);["focus","mouseover","click","load","transitionend","animationend"].forEach(function(e){D[P](e,a,true)});if(/d$|^c/.test(D.readyState)){l()}else{q("load",l);D[P]("DOMContentLoaded",a);I(l,2e4)}if(k.elements.length){t();ee._lsFlush()}else{a()}},checkElems:a,unveil:R,_aLSL:o}}(),re=function(){var a;var n=te(function(e,t,a,i){var r,n,s;e._lazysizesWidth=i;i+="px";e.setAttribute("sizes",i);if(j.test(t.nodeName||"")){r=t.getElementsByTagName("source");for(n=0,s=r.length;n<s;n++){r[n].setAttribute("sizes",i)}}if(!a.detail.dataAttr){Y(e,a.detail)}});var i=function(e,t,a){var i;var r=e.parentNode;if(r){a=s(e,r,a);i=X(e,"lazybeforesizes",{width:a,dataAttr:!!t});if(!i.defaultPrevented){a=i.detail.width;if(a&&a!==e._lazysizesWidth){n(e,r,i,a)}}}};var e=function(){var e;var t=a.length;if(t){e=0;for(;e<t;e++){i(a[e])}}};var t=ie(e);return{_:function(){a=D.getElementsByClassName(H.autosizesClass);q("resize",t)},checkElems:t,updateElem:i}}(),t=function(){if(!t.i&&D.getElementsByClassName){t.i=true;re._();e._()}};return I(function(){H.init&&t()}),k={cfg:H,autoSizer:re,loader:e,init:t,uP:Y,aC:K,rC:Q,hC:J,fire:X,gW:s,rAF:ee}}(e,e.document,Date);e.lazySizes=t,"object"==typeof module&&module.exports&&(module.exports=t)}("undefined"!=typeof window?window:{});
/*! bgset - v5.3.0 */
!function(e,t){var a=function(){t(e.lazySizes),e.removeEventListener("lazyunveilread",a,!0)};t=t.bind(null,e,e.document),"object"==typeof module&&module.exports?t(require("lazysizes")):"function"==typeof define&&define.amd?define(["lazysizes"],t):e.lazySizes?a():e.addEventListener("lazyunveilread",a,!0)}(window,function(e,z,c){"use strict";var g,y,b,f,r,l,s,v,m;e.addEventListener&&(g=c.cfg,y=/\s+/g,b=/\s*\|\s+|\s+\|\s*/g,f=/^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/,r=/^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/,l=/\(|\)|'/,s={contain:1,cover:1},v=function(e,t){var a;t&&((a=t.match(r))&&a[1]?e.setAttribute("type",a[1]):e.setAttribute("media",g.customMedia[t]||t))},m=function(e){var t,a,r,i,s;e.target._lazybgset&&(a=(t=e.target)._lazybgset,(r=t.currentSrc||t.src)&&(i=l.test(r)?JSON.stringify(r):r,(s=c.fire(a,"bgsetproxy",{src:r,useSrc:i,fullSrc:null})).defaultPrevented||(a.style.backgroundImage=s.detail.fullSrc||"url("+s.detail.useSrc+")")),t._lazybgsetLoading&&(c.fire(a,"_lazyloaded",{},!1,!0),delete t._lazybgsetLoading))},addEventListener("lazybeforeunveil",function(e){var t,a,r,i,s,l,n,d,u,o;!e.defaultPrevented&&(t=e.target.getAttribute("data-bgset"))&&(u=e.target,(o=z.createElement("img")).alt="",o._lazybgsetLoading=!0,e.detail.firesLoad=!0,a=t,r=u,i=o,s=z.createElement("picture"),l=r.getAttribute(g.sizesAttr),n=r.getAttribute("data-ratio"),d=r.getAttribute("data-optimumx"),r._lazybgset&&r._lazybgset.parentNode==r&&r.removeChild(r._lazybgset),Object.defineProperty(i,"_lazybgset",{value:r,writable:!0}),Object.defineProperty(r,"_lazybgset",{value:s,writable:!0}),a=a.replace(y," ").split(b),s.style.display="none",i.className=g.lazyClass,1!=a.length||l||(l="auto"),a.forEach(function(e){var t,a=z.createElement("source");l&&"auto"!=l&&a.setAttribute("sizes",l),(t=e.match(f))?(a.setAttribute(g.srcsetAttr,t[1]),v(a,t[2]),v(a,t[3])):a.setAttribute(g.srcsetAttr,e),s.appendChild(a)}),l&&(i.setAttribute(g.sizesAttr,l),r.removeAttribute(g.sizesAttr),r.removeAttribute("sizes")),d&&i.setAttribute("data-optimumx",d),n&&i.setAttribute("data-ratio",n),s.appendChild(i),r.appendChild(s),setTimeout(function(){c.loader.unveil(o),c.rAF(function(){c.fire(o,"_lazyloaded",{},!0,!0),o.complete&&m({target:o})})}))}),z.addEventListener("load",m,!0),e.addEventListener("lazybeforesizes",function(e){var t,a,r,i;e.detail.instance==c&&e.target._lazybgset&&e.detail.dataAttr&&(t=e.target._lazybgset,r=t,i=(getComputedStyle(r)||{getPropertyValue:function(){}}).getPropertyValue("background-size"),!s[i]&&s[r.style.backgroundSize]&&(i=r.style.backgroundSize),s[a=i]&&(e.target._lazysizesParentFit=a,c.rAF(function(){e.target.setAttribute("data-parent-fit",a),e.target._lazysizesParentFit&&delete e.target._lazysizesParentFit})))},!0),z.documentElement.addEventListener("lazybeforesizes",function(e){var t,a;!e.defaultPrevented&&e.target._lazybgset&&e.detail.instance==c&&(e.detail.width=(t=e.target._lazybgset,a=c.gW(t,t.parentNode),(!t._lazysizesWidth||a>t._lazysizesWidth)&&(t._lazysizesWidth=a),t._lazysizesWidth))}))});

jQuery(document).ready(function ($) {


  function show_nav() {
    $('.mobile_nav').addClass('active');
    $('.sticky_wrap, .footer, .header').addClass('nav_slide');
    //Create overlay
    $('body').append('<div id="content_overlay"></div>');

  }

  function hide_nav() {
    $('.mobile_nav').removeClass('active');
    $('.sticky_wrap, .footer, .header').removeClass('nav_slide');
    $('#content_overlay').remove();
  }

  $('.mobile_toggle').click(function () {
    show_nav();
  });

  $(document).on('click touchstart', '#content_overlay', function () {
    hide_nav();
  });


  var navigationMegaMenu = $('.js-navigation-mega-menu');
  var header = $('.header');

  $(window).on('scroll load',function () {
    if ($(this).scrollTop() > 500) {
      $('.back-to-top').addClass('back-to-top--visible');
    } else {
      $('.back-to-top').removeClass('back-to-top--visible');
    }

    if ($(this).scrollTop() > 90) {
      navigationMegaMenu.addClass('navigation-mega-menu--fixed')
      header.addClass('header--fixed');
    } else {
      navigationMegaMenu.removeClass('navigation-mega-menu--fixed')
      header.removeClass('header--fixed');
    }


  });

  $('.back-to-top').click(function () {
    $("html, body").animate({scrollTop: "0"});
  });


  $(document).on('click touchstart', '#content_overlay', function () {
    $('.m_toggle').trigger("click");
    return false;
  });

  $('.home_slider').flexslider({
    controlNav: false
  });


  $(".js-lightgallery").lightGallery({
    selector: '.js-gallery-item',
    zoom: false,
    download: false,
    actualSize: false,
    scale: 0.5,
    enableDrag : false,
    enableSwipe :false
  });

  $(".js-lightgallery-customer").lightGallery({
    selector: '.js-gallery-item-customer',
    zoom: false,
    download: false,
    actualSize: false,
    scale: 1,
    enableDrag : false,
    enableSwipe :false
  });

  $(".js-lightgallery,.js-lightgallery-customer").on('onAfterSlide.lg onSlideItemLoad.lg onAfterOpen.lg',function(event, index){
    console.log();
    var zoomImage = $('.lg-item.lg-current .lg-img-wrap').find('.lg-image');
    if (zoomImage.height() / zoomImage.width() > 2){
        var magnifyLevel = 0.5;
    } else {
        var magnifyLevel = 1;
    }
    $('.lg-item.lg-current .lg-img-wrap').zoom({
      on:'click',
      magnify: magnifyLevel
    });
    $('.lg-object.lg-image').attr('data-pin-no-hover',true);
  });

  /*$(".js-lightgallery").on('onSlideItemLoad.lg',function(event, index){
    $('.lg-img-wrap:eq('+index+')').zoom({
      on:'toggle',
      magnify: 2,
      onZoomIn : function(){
        $(this).css('opacity','0');
        $(this).parents('.lg-img-wrap').addClass('zoomed');
        var left = parseInt($(this).css('left').replace('-','').replace('px',''));
        var top = parseInt($(this).css('top').replace('-','').replace('px',''));
        $(this).addClass('manual');
        $(this).parents('.lg-img-wrap').scrollLeft(left);
        $(this).parents('.lg-img-wrap').scrollTop(top);
        $(this).css('opacity','1');
      },
      onZoomOut : function(){
        $(this).removeClass('manual');
        $(this).parents('.lg-img-wrap').removeClass('zoomed');
        $(this).parents('.lg-img-wrap').scrollTop(0).scrollLeft(0);
      }
    });
    $('.lg-object.lg-image').attr('data-pin-no-hover',true);
  });*/

  $('.js-product-thumbs').flexslider({
    animation: "slide",
    animationLoop: false,
    controlNav: false,
    itemWidth: 100,
    itemMargin: 5
  });

  $('.fabric-thumbs-js').flexslider({
    animation: "slide",
    animationLoop: false,
    controlNav: false,
    itemWidth: 50,
    itemMargin: 10
  });

  $('.search_field').focus(function () {
    $(this).addClass('active');
    $(this).closest('.search').addClass('active');
  });

  $('.search_field').focusout(function () {
    $(this).removeClass('active');
    $(this).closest('.search').removeClass('active');
  });

  $(".fancybox").fancybox({
    padding: 40,
    helpers: {
      overlay: {
        locked: false,
        css: {
          'border-radius': '0px'
        }
      }
    }


  });


  $(".gallery li a").fancybox({
    padding: 40,
    helpers: {
      overlay: {
        locked: false,
        css: {
          'border-radius': '0px'
        }
      }
    },

    beforeShow: function () {
      var store = $(this.element).data('store');
      var title = $(this.element).attr('title');
      var photo = $(this.element).data('photo');
      this.title = (title + '<a class="buy_btn" href="' + store + '">Buy Now</a>' + '<br />' + '<div class="photo_by">Photo by:' + photo + '</div>');
    }

  });

  $('.popup__close').on('click', function () {
    $(this).closest('.popup').removeClass('active');
    $(this).closest('.popup').addClass('hide');
  });

  $('.js-show-popup').on('click', function (evt) {
    evt.preventDefault();
    $('.popup').addClass('active');
  });

  $('#trigger_popup_cut_lines').on('click', function (evt) {
    evt.preventDefault();
    $('#popup-cut-lines').addClass('active').removeClass('hide');
  });

  $(document).ready(function () {
    $('#subscribe-promo-code, #subscribe-result').hide();
    ajaxMailChimpForm($("#subscribe-form"), $("#subscribe-result"));
    // Turn the given MailChimp form into an ajax version of it.
    // If resultElement is given, the subscribe result is set as html to
    // that element.
    function ajaxMailChimpForm($form, $resultElement) {
      // Hijack the submission. We'll submit the form manually.
      $form.submit(function (e) {
        e.preventDefault();
        if (!isValidEmail($form)) {
          var error = "A valid email address must be provided.";
          $resultElement.html(error);
          $resultElement.css("color", "red");
        } else {
          $resultElement.css("color", "black");
          $resultElement.html("Subscribing...");
          submitSubscribeForm($form, $resultElement);
        }
      });
    }

    // Validate the email address in the form
    function isValidEmail($form) {
      // If email is empty, show error message.
      // contains just one @
      var email = $form.find("input[type='email']").val();
      if (!email || !email.length) {
        return false;
      } else if (email.indexOf("@") == -1) {
        return false;
      }
      return true;
    }

    // Submit the form with an ajax/jsonp request.
    // Based on http://stackoverflow.com/a/15120409/215821
    function submitSubscribeForm($form, $resultElement) {
      $.ajax({
        type: "POST",
        url: $form.attr("action"),
        data: $form.serialize(),
        cache: false,
        dataType: "jsonp",
        jsonp: "c", // trigger MailChimp to return a JSONP response
        contentType: "application/json; charset=utf-8",
        error: function (error) {
          // According to jquery docs, this is never called for cross-domain JSONP requests
        },
        success: function (data) {
          if (data.result != "success") {
            var message = data.msg || "Sorry. Unable to subscribe. Please try again later.";
            $resultElement.css("color", "red");
            if (data.msg && data.msg.indexOf("already subscribed") >= 0) {
              message = "You're already subscribed. Thank you.";
              $resultElement.css("color", "black");
            }
            $resultElement.html(message);
            $resultElement.show();
          } else {
            $resultElement.parents('.mail_signup').addClass('submitted');
            $resultElement.css("color", "black");
            $resultElement.html("Thank you!<br>Here's your promo code:");
            $resultElement.show();
            $('.form-container').hide();
            $('#subscribe-promo-code').html('firstimer10').show();
          }
        }
      });
    }
  });


  /* Product Gallery v2 */
  $('.product_thumbs .thumb_nav.prev').click(function(){
  	var ulElement = $(this).next().find('ul');
    var currentTop = parseInt(ulElement.css("top"));
    var newTop = parseInt(ulElement.css("top")) + 85;
    ulElement.css('top',newTop);
    $('.product_thumbs .thumb_nav.next').removeClass('disabled');
    if(newTop == 0){
      $(this).addClass('disabled');
    }
  });

  $('.product_thumbs .thumb_nav.next').click(function(){
  	var ulElement = $(this).prev().find('ul');
    var currentTop = parseInt(ulElement.css("top"));
    var newTop = parseInt(ulElement.css("top")) - 85;
    ulElement.css('top',newTop);
    $('.product_thumbs .thumb_nav.prev').removeClass('disabled');
    var containerHeight = $(this).prev().height();
    var slideHeight = ulElement.height() - 5;
    if(containerHeight - newTop == slideHeight){
      $(this).addClass('disabled');
    }
  });

  let styleGallerySlides = $('.style-gallery-slides').flickity({
      pageDots: false,
      cellAlign: 'left',
      contain: true,
      autoplay:true,
      percentPosition:true,
      initialIndex:2,
    });


  $('.continue-shopping').click(function(){
  	if (document.referrer == "") {
      window.location.href = "/collections/all";
    } else {
      history.back();
    }
  });

  function mobile_product_gallery(){
    if ($(window).width() < 641) {
      $('.main_product_images ul').flickity({
        pageDots: false,
        contain: true,
        draggable: true,
        on: {
          select: function( index ) {
            var newIndex = index + 1;
            if($('.product-gallery-v2').hasClass('fullscreen')){
              var selectedIndex = newIndex;
            }else{
              var selectedIndex = newIndex;
            }
            var total = parseInt($('.slide_counter').attr('data-total'));
            if(selectedIndex > total){selectedIndex=total};
            $('.slide_counter .counter').text(selectedIndex);
          }
        }
      });
    }else{
      if($('.main_product_images ul').data('flickity')){
        $('.main_product_images ul').flickity('destroy');
      }
    }
  }


  /*$('.product-gallery-v2 .thumb').click(function(){
    var index = $(this).attr('data-index');
    $('.thumb').removeClass('active');
    $(this).addClass('active');
    $('.product-gallery-v2 .main_product_images').find('li[data-index='+index+']').addClass('active').siblings().removeClass('active');
    var active_image = $('.product-gallery-v2 .main_product_images li.active img');
    if($('.product-gallery-v2').hasClass('fullscreen')){
      active_image.attr('src',active_image.attr('data-full-src'));
    }else{
      active_image.attr('src',active_image.attr('data-low-src'));
    }
  });
  */
  /*$('.product-gallery-v2 .main_product_images li').click(function(){
    if ($(window).width() < 641) {

      $('.product-gallery-v2 .main_product_images li').each(function(){
        $(this).find('img').attr('src',$(this).find('img').attr('data-full-src'));
      });


      if($('.product-gallery-v2').hasClass('fullscreen')){
        $(this).toggleClass('zoom-li');
        if($(this).hasClass('zoom-li')){
          $(this).animate({
            scrollTop: $(this).offset().top + $(this).height() / 2,
            scrollLeft: $(this).offset().left + $(this).width() / 2,
          }, 0);
        }
      }else{
        $('body').addClass('fixed');
        $('.product-gallery-v2').addClass('fullscreen');
        $('.main_product_images ul').flickity('destroy');
        mobile_product_gallery();
        var active_index = parseInt($(this).attr('data-index')) - 1;
        $('.main_product_images ul').flickity( 'select', active_index );
      }
    }else{
      $('.product-gallery-v2').toggleClass('fullscreen');
      var active_image = $('.product-gallery-v2 .main_product_images li.active img');
      active_image.attr('src',active_image.attr('data-full-src'));
      $('body').toggleClass('fixed');
    }
  });

  $('.product-gallery-v2 .close_gallery').click(function(){
    $('.product-gallery-v2').toggleClass('fullscreen');
    var active_image = $('.product-gallery-v2 .main_product_images li.active img');
    active_image.attr('src',active_image.attr('data-full-src'));
    $('body').toggleClass('fixed');
    if ($(window).width() < 641) {
      $('.main_product_images ul').flickity('destroy');
      mobile_product_gallery();
    }
  });*/

  mobile_product_gallery();
  $(window).resize(function() {
    mobile_product_gallery();
  });

 $("body").on("contextmenu",'img',function(){
   return false;
 });

  const recomendationsSlider = document.querySelector(".js-recommendations-slider");

  if(recomendationsSlider) {
    new Swiper(recomendationsSlider, {
      slidesPerView: 2,
      spaceBetween: 10,
      navigation: {
        nextEl: '.flickity-button.next',
        prevEl: '.flickity-button.previous',
      },
      breakpoints: {
        951: {
          slidesPerView: 4,
        }
      }
    });
  }


  var existCondition = setInterval(function() {
   if ($('.recommendations-product-item').length) {
      clearInterval(existCondition);
      $('#shopify-section-product-recommendations ul').flickity({
         pageDots: false,
         cellAlign: 'left',
         contain: true,
         groupCells: true,
         draggable: true,
         adaptiveHeight: true,
         imagesLoaded: true
       });
   }
  }, 100);

  var waitForEl = function(selector, callback) {
    if ($(selector).length > 0) {
      console.log('exist '+$(selector).length);
      callback();
    } else {
      setTimeout(function() {
        console.log(selector);
        waitForEl(selector, callback);
      }, 100);
    }
  };
});


$(document).ready(function ($) {

  function initOwlCarousels () {
    $('[data-section-type="slideshow"]').each(function (){
      var config = $.parseJSON($(this).attr('data-slider-config'));
      var $slider = $(this);

      if (config) {
        initSlider();
      }

      function initSlider() {
        $slider.slick(config);

        $slider.on('click', '.Slide', function () {
          $slider.slick('slickGoTo', $(this).index() - 2);
        })
      }
    });
  }

  initOwlCarousels()

  document.addEventListener("shopify:section:load",   initOwlCarousels);

  $('video').on('click', function () {
    $(this)[0].muted = !$(this)[0].muted;
  })
  
  // $('.checkout-button').on('click', function (e) {
  //   if ($(this)[0].hasAttribute('data-discount')) {
  //     e.preventDefault();
  //
  //     const discountCode = $(this).attr('data-discount')
  //     applyDiscount(discountCode);
  //
  //   }
  // })
  
  $('.contact-form__element [data-target]').on('change', function (e) {
    const target = $(this).attr('data-target')
    const value = $(this).val()
    const $form = $(this).parents('form')
    
    $form.find(`[data-linked="${target}"]`).attr('aria-hidden', true)
    $form.find(`[data-linked="${target}"][data-value="${value}"]`).attr('aria-hidden', false)
  })
  
  // function applyDiscount(code) {
  //   window.location = "/discount/"+code+"?v="+Date.now()+"&redirect=/checkout/"
  // }
})
/* end of as page load scripts */
